import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import styled, { css } from "styled-components";
import { SelectedItemsCount } from "../segments/styles";

export const DropdownWrapper = styled.div`
    z-index: 7;
    position: relative;
`;
export const WebsitesDropdownTitle = styled.span`
    ${setFontVariant("subtitle2")}
    color: ${colorsPalettes.carbon[500]} !important;
    margin: 0 !important;
`;

export const IndustryTitle = styled(WebsitesDropdownTitle)`
    font-size: 18px !important;
`;

export const DropdownSelector = styled.div<{ isDisabled: boolean }>`
    width: 100%;
    .DropdownButton {
        border: unset;
        ${({ isDisabled }) =>
            isDisabled
                ? css`
                      background: ${colorsPalettes.carbon[25]};
                      cursor: not-allowed;
                  `
                : ""}
    }
`;

export const WebsiteDropdownTitleWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 21px 0 8px 0;
`;

export const StyledSelectedItemsCount = styled(SelectedItemsCount)`
    margin: 0;
    ${setFontVariant("subtitle2")}
`;
